import { render, staticRenderFns } from "./AdminPasswordUpdate.vue?vue&type=template&id=8b2941f4&scoped=true"
import script from "./AdminPasswordUpdate.vue?vue&type=script&lang=js"
export * from "./AdminPasswordUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b2941f4",
  null
  
)

export default component.exports